const concat = "<br />"

const aboutspan = {
    "About Spandana Sphoorty": [
        {
          question: "What is the business of Spandana Sphoorty Financial Limited (Spandana)?",
          answer: "Spandana is a publicly listed company in India, registered as a non-deposit accepting NBFC with the RBI and classified as an NBFC-MFI effective April 13, 2015. Spandana, together with its subsidiaries, is primarily engaged in lending, providing small-value unsecured loans to low income customers in semi-urban and rural areas." + concat + concat +
            "The tenure of these loans is generally spread over 1-2 years. While Spandana extends microfinance loans, its subsidiaries extend other services such as loan against property, gold loans, business loans and personal loans."
        },
        {
          question: "Who are the promoters of Spandana?",
          answer: "The total promoter holding is 63% of which Kedaara Capital (directly and indirectly) is the largest shareholder with a total shareholding of 48.34%."
        },
        {
          question: "What are the strengths of Spandana?",
          answer: "- Long Track record of the company in the Micro Finance Business and operating over different business cycles." + concat +
          "- Regional Diversity in Asset base – Present in 19 states with 1,221 branches" + concat +
          "- Improved asset quality with low NPAs - GNPA: 1.63% and NNPA : 0.49%" + concat +
          "- Healthy Capitalization – Capital Adequacy ratio is 37.0% which is significantly higher than RBI minimum limit of 15%" + concat +
          "- Strong Promoter – Kedaara Capital is a PE investor with 48.34% investment" + concat +
          "- Diversified Borrowing – A healthy mix of borrowing from Banks, Financial Institutions and Capital Markets. Banks & FI’s contribute to 65% of borrowing." + concat
        },
        {
          question: "What are the major risks to Spandana?",
          answer: "- The Microfinance business is susceptible to Socio-political issues." + concat +
          "- Inherent weakness in the borrower credit risk profile." + concat
        },
        {
          question: "What is the Credit rating for Spandana?",
          answer: "Spandana is rated A/ Stable by CRISIL, ICRA and India Ratings."
        },
        {
          question: "What is the AUM of  Spandana Sphoorty?",
          answer: "The Consolidated AUM as on 30th Jun 2023 is ₹ 8,848 Crs."
        },
        {
          question: "What is the profitability of  Spandana Sphoorty?",
          answer: "The Yield of the portfolio is 24.0%" + concat + 
            "Net Interest Income is ₹ 328 Crs" + concat +
            "Profit Before Tax (PBT) is ₹ 161 Crs" + concat +
            "Profit After Tax (PAT) is ₹ 119 Crs" + concat +
            "(Data for Q1FY24)"          
        },
        {
          question: "What is the Net Interest margin of  Spandana Sphoorty?",
          answer: "Spandana operates at a healthy NIM of 14.2%"
        },
        {
          question: "How is the asset quality of Spandana?",
          answer: "The consolidated NPAs of Spandana as on Jun 2023 are relatively low with GNPA: 1.63% and NNPA : 0.49%. The Provision Coverage Ratio (PCR) is 70%."
        },
        {
          question: "What is the Capital Adequacy ratio? ",
          answer: "The consolidated Capital Adequacy Ratio (CRAR) as on Jun 2023 is 37.6%"
        },
      ],
  }
  
  export default aboutspan;